import { Form, Offcanvas } from "react-bootstrap";
import { set, useForm } from "react-hook-form";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

interface IesaAdvantage {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  name: string;
  designation: string;
  linkedinUrl: string;
  image: File | null;
};

const AddOurTeam = ({ show, handleClose, data }: IesaAdvantage) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormData>();
  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  console.log("a", data);
  useEffect(() => {
    if (data) {
      reset({
        name: data.name,
        designation: data.designation,
        linkedinUrl: data.linkedinUrl || "",
      });
      setPreviewUrl(data.originalImage || null);
    } else {
      reset({});
      setPreviewUrl("");
    }
  }, [show]);
  const ALLOWED_IMAGE_TYPES = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/svg+xml",
  ];
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target;
    const file = input.files?.[0];

    if (!file) return;
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      const msg =
        "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

      toast.error(msg);
      setFile(null);
      setPreviewUrl("");
      input.value = "";
      return;
    }
    setFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };
  const onSubmit = (request: FormData) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("name", request.name);
    formData.append("designation", request.designation);
    formData.append("linkedinUrl", request.linkedinUrl);
    if (file) {
      formData.append("image", file);
    }
    if (data?._id) {
      WebService.fileUploadPutAPI({
        action: `our-team/editTeamMember/${data._id}`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    } else {
      WebService.fileUploadAPI({
        action: `our-team/addTeamMember`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={() => {
        reset();
        handleClose();
      }}
      placement="end"
      className="offcanvas-custom"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {data ? "Edit Team Member" : "Add Team Member"}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2" controlId="title">
            <Form.Label className="label">
              Name<span className="text-danger"> *</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name"
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && (
              <div className="error-message">{errors.name.message}</div>
            )}
          </Form.Group>
          <Form.Group className="mb-2" controlId="eventLocation">
            <Form.Label className="label">
              Designation<span className="text-danger"> *</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter designation"
              {...register("designation", {
                required: "Designation is required",
              })}
            />
            {errors.designation && (
              <div className="error-message">{errors.designation.message}</div>
            )}
          </Form.Group>
          <Form.Group className="mb-2" controlId="linkedinUrl">
            <Form.Label className="label">
              LinkedIn URL
            </Form.Label>
            <Form.Control
              type="url"
              placeholder="https://www.linkedin.com/in/username"
              {...register("linkedinUrl", {
                pattern: {
                  value:
                    /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,3})+(\/[^\s]*)?$/,
                  message: "Please enter a valid LinkedIn profile URL",
                },
              })}
            />
            {errors.linkedinUrl && (
              <div className="error-message">{errors.linkedinUrl.message}</div>
            )}
          </Form.Group>
          <Form.Group className="mb-2" controlId="icon">
            <Form.Label className="label">Image <span className="text-danger"> *</span></Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              className="custom-image-upload"
              ref={fileInputRef}
              onChange={handleFileChange}
            />
            <div
              className="text-primary mt-1"
              style={{ fontSize: "13px" }}
            >
              Note: Please upload an image of size:{" "}
              <strong>130 × 128 px</strong> in{" "}
              <strong>.png, .jpeg, .jpg or .svg</strong> format.
            </div>
          </Form.Group>
          {previewUrl && (
            <div className="mb-2 event-image">
              <img
                src={previewUrl}
                alt="Image Preview"
                style={{
                    maxWidth: "100%",
                    maxHeight: 200,
                    objectFit: "contain",
                  }}
              />
            </div>
          )}
        </Form>
      </Offcanvas.Body>
      <div className="d-flex justify-content-end p-3">
        <CustomButton
          isLoading={isLoading}
          label="Save"
          className="w-100"
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </Offcanvas>
  );
};

export default AddOurTeam;
